import React, { type ReactNode } from 'react';
import { CrossIcon } from '@mentimeter/ragnar-visuals';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { useTranslations } from 'use-intl';
import { Box } from '../box';
import type { BoxT } from '../box';
import { Clickable } from '../clickable';
import { ModalTitle } from './ModalTitle';
import { ModalDismiss } from './ModalDismiss';

interface ModalHeaderProps extends BoxT {
  size?: 'medium' | 'large';
  dismissable?: boolean;
  dismissLabel?: string;
  onDismissClick?: () => void;
  children: ReactNode;
}

export const ModalHeader = ({
  size,
  dismissable = true,
  dismissLabel,
  onDismissClick,
  children,
  className,
  ...boxProps
}: ModalHeaderProps) => {
  const t = useTranslations('ragnar.modal');
  const closeLabel = dismissLabel ? dismissLabel : t('close_modal_button_a11y');

  return (
    <Box
      className={clsx(
        ['w-full', 'px-8', 'pb-1', dismissable ? 'pt-12' : 'pt-8'],
        className,
      )}
      {...boxProps}
    >
      <ModalTitle size={size}>{children}</ModalTitle>
      {dismissable && (
        <ModalDismiss>
          <Clickable
            aria-label={closeLabel}
            className="absolute top-0 right-0 p-4"
            onClick={onDismissClick}
          >
            <CrossIcon size={3} />
          </Clickable>
        </ModalDismiss>
      )}
    </Box>
  );
};
